/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ModulesMobileApplicationNotificationsPostNotificationMobileNotificationType = 0 | 1 | 2;

export const ModulesMobileApplicationNotificationsPostNotificationMobileNotificationType = {
    NUMBER_0: 0 as ModulesMobileApplicationNotificationsPostNotificationMobileNotificationType,
    NUMBER_1: 1 as ModulesMobileApplicationNotificationsPostNotificationMobileNotificationType,
    NUMBER_2: 2 as ModulesMobileApplicationNotificationsPostNotificationMobileNotificationType
};